import {gql} from '@apollo/client';
import {useCallback} from 'react';
import Artists, {GqlArtistFragment} from 'src/components/Artists';
import {useQuery} from 'src/hooks';
import InfiniteScroll from './InfiniteScroll';
import {QueryNewArtists} from './__generated__/QueryNewArtists';

const PAGE_LIMIT = 20;

const GQL_ARTISTS = gql`
  query QueryNewArtists($first: Int!, $skip: Int!) {
    artists(
      first: $first
      skip: $skip
      subgraphError: allow
      orderBy: mintedAt
      orderDirection: desc
      where: {mintedAt_gt: 0}
    ) {
      ...ArtistFragment
    }
  }
  ${GqlArtistFragment}
`;

export default function ExploreArtists() {
  const {data, loading, fetchMore} = useQuery<QueryNewArtists>(GQL_ARTISTS, {
    variables: {
      first: PAGE_LIMIT,
      skip: 0,
    },
  });

  const handleLoadMore = useCallback(async () => {
    const result = await fetchMore({variables: {skip: data?.artists?.length}});
    return result.data?.artists;
  }, [data, fetchMore]);

  return (
    <>
      <h1>Recently Minted Artists</h1>
      <InfiniteScroll
        pageLimit={PAGE_LIMIT}
        data={data?.artists}
        onLoadMore={handleLoadMore}
        loading={loading}
        children={(artists) => <Artists artists={artists} showExtraInfo />}
      />
    </>
  );
}
